export const EyeView = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.238281"
      y="0.664062"
      width="45.2365"
      height="38.1576"
      rx="5.30912"
      fill="#FFF0EA"
    />
    <g clipPath="url(#clip0_3522_7027)">
      <path
        d="M22.8574 22.7422C24.5143 22.7422 25.8574 21.399 25.8574 19.7422C25.8574 18.0853 24.5143 16.7422 22.8574 16.7422C21.2006 16.7422 19.8574 18.0853 19.8574 19.7422C19.8574 21.399 21.2006 22.7422 22.8574 22.7422Z"
        fill="#ED5E2A"
      />
      <path
        d="M34.0621 19.4872C33.18 17.2054 31.6486 15.2321 29.6572 13.8113C27.6658 12.3904 25.3017 11.5841 22.8571 11.4922C20.4125 11.5841 18.0484 12.3904 16.057 13.8113C14.0656 15.2321 12.5342 17.2054 11.6521 19.4872C11.5925 19.652 11.5925 19.8324 11.6521 19.9972C12.5342 22.279 14.0656 24.2522 16.057 25.6731C18.0484 27.094 20.4125 27.9003 22.8571 27.9922C25.3017 27.9003 27.6658 27.094 29.6572 25.6731C31.6486 24.2522 33.18 22.279 34.0621 19.9972C34.1217 19.8324 34.1217 19.652 34.0621 19.4872ZM22.8571 24.6172C21.8929 24.6172 20.9504 24.3313 20.1487 23.7956C19.347 23.2599 18.7222 22.4986 18.3532 21.6078C17.9842 20.717 17.8877 19.7368 18.0758 18.7911C18.2639 17.8455 18.7282 16.9768 19.41 16.295C20.0917 15.6133 20.9604 15.149 21.906 14.9609C22.8517 14.7728 23.8319 14.8693 24.7227 15.2383C25.6135 15.6073 26.3748 16.2321 26.9105 17.0338C27.4462 17.8355 27.7321 18.778 27.7321 19.7422C27.7301 21.0345 27.2159 22.2733 26.3021 23.1871C25.3882 24.101 24.1494 24.6152 22.8571 24.6172Z"
        fill="#ED5E2A"
      />
    </g>
    <defs>
      <clipPath id="clip0_3522_7027">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(10.8574 7.74219)"
        />
      </clipPath>
    </defs>
  </svg>
);
